<template>
    <div>
        <div class="tabulation-title">
            <h5>
                <v-icon>label_outline</v-icon> Documents liés à votre séjour (PDF)
            </h5>
        </div>

        <div class="pl-5 pr-5 mt-5">
            <div class="d-flex justify-content-between medias-box flex-wrap">
                <div style="width: 300px" class="mb-5 media-card">
                    <div ref="dashboardContainer"></div>
                    <div ref="dashboardProgress"></div>
                </div>

                <div>
                    <div v-for="(document, index) in currentProduct.documents">
                        <div class="d-flex">
                            <a :href="document.origin_url" target="_blank" class="mt-auto mb-auto">
                                <v-icon color="#29B6F6">open_in_new</v-icon> {{ document.name }}
                            </a>
                            <v-btn color="error" icon @click="removeFile(index)">
                                <v-icon dense>delete</v-icon>
                            </v-btn>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Confirm from "../tools/Confirm"
import {mapMutations, mapState} from "vuex"
import Uppy from "@uppy/core"
import French from "@uppy/locales/lib/fr_FR"
import Dashboard from "@uppy/dashboard"
import ProgressBar from "@uppy/progress-bar"
import AwsS3 from "@uppy/aws-s3"

export default {
    name: "ProductFile",
    components: {Confirm},
    props: ['disabled'],
    data() {
        return {
            selectedMedia: null,
            showFullScreen: false,
            uppy: null,
            addMod: false
        }
    },
    methods: {
        pushMedia(originUrl, thumbnailUrl, source = null, temp = true, name = null) {
            let media = {
                thumbnail_url: thumbnailUrl,
                name: name,
                copyright: null,
                temp: temp,
                origin_url: originUrl,
                url: originUrl,
                source: source,
                is_image: false
            }

            this.currentProduct.documents.push(media)
        },
        dec2hex (dec) {
            return dec < 10
                ? '0' + String(dec)
                : dec.toString(16)
        },
        generateId (len) {
            let arr = new Uint8Array((len || 40) / 2)
            window.crypto.getRandomValues(arr)
            return Array.from(arr, this.dec2hex).join('')
        },
        removeFile(index) {
            this.currentProduct.documents.splice(index, 1)
        }
    },
    computed: {
        ...mapState('aura', ['currentProduct']),
    },
    mounted() {
        if(!this.disabled) {
            let self = this

            this.uppy = Uppy({
                debug: true,
                autoProceed: true,
                locale: French,
                restrictions: {
                    maxFileSize: 10485760,
                    allowedFileTypes: ['application/pdf']
                }
            }).use(Dashboard, {
                hideUploadButton: true,
                inline: true,
                height: 337,
                width: 'auto',
                target: this.$refs.dashboardContainer,
                replaceTargetContent: true,
                showProgressDetails: true,
                browserBackButtonClose: true,
                theme: 'light',
                locale: {
                    strings: {
                        dropPaste: 'Déposer les fichiers ici depuis votre %{browse}',
                        browse: 'ordinateur ou smartphone',
                    }
                },
                proudlyDisplayPoweredByUppy: false,
                showSelectedFiles: false
            }).use(ProgressBar, {
                target: this.$refs.dashboardProgress,
                hideAfterFinish: false
            }).use(AwsS3, {
                companionUrl: process.env.VUE_APP_API_URL + '/api/companion',
                getUploadParameters (file) {
                    return fetch(process.env.VUE_APP_API_URL + '/api/companion', {
                        method: 'post',
                        headers: {
                            accept: 'application/json',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            filename: self.generateId(20) + '.' + file.extension,
                            contentType: file.type,
                            origin_filename: file.name
                        })
                    }).then((response) => {
                        return response.json()
                    }).then((data) => {
                        return {
                            method: data.method,
                            url: data.url,
                            fields: data.fields,
                            headers: data.headers,
                            filename: data.filename
                        }
                    })
                }
            })

            this.uppy.on('complete', (event) => {
                if(event.successful !== undefined) {
                    event.successful.forEach(result => {
                        let path = result.response.body.location
                        this.pushMedia(path, path, null, true, result.name)
                    })
                }

                this.uppy.reset()
            })
        }
    }
}
</script>